/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import {
  InputV2,
  InputFormatV2,
  MalhaSelectV2,
  GerenciaSelectV2,
  PoloSelectV2,
  SubestacaoSelectV2,
  AlimentadorSelectV2,
  DatePickerV2,
  DefaultSelectV2,
  SimNaoSelectV2,
  UsuarioSelectV2,
  TrueFalseSelectV2,
} from '../../../../components/v2';
import * as Roles from '../../../../constants/role';
import * as Status from '../../../../constants/status';
import { isFalse, isInspecaoMtBt, isNullOrUndefined, isTrue } from 'utils';

const InformacaoBasicaForm = ({
  values,
  setValues,
  handleChange,
  errors,
  isAdmin,
  usuarioCroquiPodeEditar,
  podeEditarAuditoria,
}) => (
  <>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        label="NSIR"
        name="codigo"
        onChange={handleChange}
        value={values.codigo || ''}
        disabled={!isAdmin}
        isRequired
        error={!!(errors && errors.codigo)}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        error={!!(errors && errors.equipamento)}
        isRequired
        label="Equipamento"
        name="equipamento"
        onChange={handleChange}
        value={values.equipamento || ''}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <DatePickerV2
        label="Data Vencimento"
        onChange={(data) =>
          setValues({
            ...values,
            vencimento: data.valueOf(),
          })
        }
        value={values.vencimento}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <DefaultSelectV2
        error={!!(errors && errors.area)}
        isRequired
        label="Área"
        name="area"
        showEmpty
        options={[
          { id: 'RDR', nome: 'Rural' },
          { id: 'RDU', nome: 'Urbana' },
        ]}
        onSelect={handleChange}
        value={values.area}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <SimNaoSelectV2
        error={!!(errors && errors.prioridade)}
        label="Prioridade"
        name="prioridade"
        onChange={handleChange}
        value={values.prioridade}
        disabled={!isAdmin}
        isRequired
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <SimNaoSelectV2
        error={!!(errors && errors.anomalia)}
        label="Anomalia"
        name="anomalia"
        onChange={handleChange}
        value={values.anomalia}
        disabled={!isAdmin}
        isRequired
      />
    </Grid>
    {isInspecaoMtBt(values.tipoServicoId) && (
      <>
        <Grid size={{ xs: 6, sm: 2 }}>
          <TrueFalseSelectV2
            label="Adere"
            disabled={!isAdmin}
            isRequired
            error={!!(errors && errors.possuiAdere)}
            onChange={(event) => {
              const value = event.target.value;
              if (value === 'false' || isNullOrUndefined(value)) {
                setValues({ ...values, possuiAdere: value, adereMonth: '' });
              } else {
                setValues({ ...values, possuiAdere: value });
              }
            }}
            value={values.possuiAdere}
          />
        </Grid>
        <Grid size={{ xs: 6, sm: 2 }}>
          <InputFormatV2
            error={isTrue(values.possuiAdere) && !!(errors && errors.adereMonth)}
            name="adereMonth"
            label="Adere Mês/Ano"
            value={values.adereMonth || ''}
            onChange={handleChange}
            disabled={!isAdmin || isFalse(values.possuiAdere)}
            format="##/####"
          />
        </Grid>
      </>
    )}
    <Grid size={{ xs: 6, sm: 2 }}>
      <UsuarioSelectV2
        label="Inspetor"
        onSelect={(inspetorId) => setValues({ ...values, inspetorId })}
        ativo
        showMatriculaCemig
        grupos={[Roles.ADMIN, Roles.INSPETOR]}
        value={values.inspetorId}
        disabled={values.status !== Status.EM_CRIACAO || (!isAdmin && !usuarioCroquiPodeEditar)}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <UsuarioSelectV2
        label="Observador/Ajudante"
        value={values.inspetorAuxiliarId}
        disabled
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <UsuarioSelectV2
        label="Digitador"
        onSelect={(digitadorId) => setValues({ ...values, digitadorId })}
        ativo
        grupos={[Roles.ADMIN, Roles.DIGITADOR]}
        value={values.digitadorId}
        disabled={
          [Status.AGUARDANDO_DIGITACAO, Status.EM_DIGITACAO, Status.DIGITACAO_FINALIZADA, Status.EXECUTADA_GDIS].includes(values.status)
          || !isAdmin
        }
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2 label="Data Inspeção" value={values.dataFinalInspecaoValue || ''} disabled />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2 label="Data Digitação" value={values.dataFinalDigitacaoValue || ''} disabled />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2 label="Data Executada GDIS" value={values.dataConclusaoValue || ''} disabled />
    </Grid>
    <Grid size={{ xs: 3, sm: 2 }}>
      <InputV2
        label="CT Plan"
        name="ctPlan"
        onChange={handleChange}
        value={values.ctPlan || ''}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 3, sm: 2 }}>
      <InputV2
        label="CT Exec"
        name="ctExec"
        onChange={handleChange}
        value={values.ctExec || ''}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 2 }}>
      <MalhaSelectV2
        error={!!(errors && errors.malhaId)}
        isRequired
        onSelect={(value) =>
          setValues({
            ...values,
            malhaId: value,
            gerenciaId: null,
            poloId: null,
            subestacaoId: null,
            alimentadorId: null,
          })
        }
        value={values.malhaId}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: isInspecaoMtBt(values.tipoServicoId) ? 2 : 3 }}>
      <GerenciaSelectV2
        onSelect={(value) =>
          setValues({
            ...values,
            gerenciaId: value,
            poloId: null,
            subestacaoId: null,
            alimentadorId: null,
          })
        }
        value={values.gerenciaId}
        malhaId={values.malhaId}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: isInspecaoMtBt(values.tipoServicoId) ? 2 : 3 }}>
      <PoloSelectV2
        onSelect={(value) =>
          setValues({
            ...values,
            poloId: value,
            subestacaoId: null,
            alimentadorId: null,
          })
        }
        value={values.poloId}
        malhaId={values.malhaId}
        gerenciaId={values.gerenciaId}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <SubestacaoSelectV2
        onSelect={(value) =>
          setValues({
            ...values,
            subestacaoId: value,
            alimentadorId: null,
          })
        }
        value={values.subestacaoId}
        malhaId={values.malhaId}
        gerenciaId={values.gerenciaId}
        poloId={values.poloId}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <AlimentadorSelectV2
        onSelect={(value) =>
          setValues({
            ...values,
            alimentadorId: value,
          })
        }
        value={values.alimentadorId}
        malhaId={values.malhaId}
        gerenciaId={values.gerenciaId}
        poloId={values.poloId}
        subestacaoId={values.subestacaoId}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputFormatV2
        error={!!(errors && errors.latitude)}
        helperText={errors && errors.latitude ? 'O campo é inválido' : ''}
        name="latitude"
        label="Latitude"
        value={values.latitude || ''}
        onChange={handleChange}
        disabled={!isAdmin}
        format="##,######"
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputFormatV2
        error={!!(errors && errors.longitude)}
        helperText={errors && errors.longitude ? 'O campo é inválido' : ''}
        name="longitude"
        label="Longitude"
        value={values.longitude || ''}
        onChange={handleChange}
        disabled={!isAdmin}
        format="##,######"
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        label="Km"
        name="km"
        onChange={handleChange}
        value={values.km || ''}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        label="Km Urbano"
        name="kmRdu"
        onChange={handleChange}
        value={values.kmRdu || ''}
        disabled={!isAdmin && !usuarioCroquiPodeEditar}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        label="Km Rural"
        name="kmRdr"
        onChange={handleChange}
        value={values.kmRdr || ''}
        disabled={!isAdmin && !usuarioCroquiPodeEditar}
      />
    </Grid>
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        label="Km Inspecionado"
        name="kmInspecao"
        onChange={handleChange}
        value={values.kmInspecao || ''}
        disabled={!isAdmin && !usuarioCroquiPodeEditar}
      />
    </Grid>
    {isInspecaoMtBt(values.tipoServicoId) && (
      <Grid size={{ xs: 6, sm: 2 }}>
        <InputFormatV2
          label="Quantidade de Postes"
          name="qtdPostes"
          onChange={handleChange}
          value={values.qtdPostes || ''}
          disabled={!isAdmin}
          format="######"
          error={!!(errors && errors.qtdPostes)}
        />
      </Grid>
    )}
    <Grid size={{ xs: 6, sm: 2 }}>
      <InputV2
        label="Situação"
        name="situacao"
        onChange={handleChange}
        value={values.situacao || ''}
        disabled={!isAdmin}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: isInspecaoMtBt(values.tipoServicoId) ? 2 : 6 }}>
      <InputV2
        label="Cidade"
        name="cidade"
        onChange={handleChange}
        value={values.cidade || ''}
        disabled={!isAdmin}
      />
    </Grid>
    {values.id && isInspecaoMtBt(values.tipoServicoId) && (
      <Grid size={{ xs: 6, sm: 2 }}>
        <TrueFalseSelectV2
          label="Auditoria"
          name="auditoria"
          disabled={!podeEditarAuditoria}
          showEmpty
          error={!!(errors && errors.auditoria)}
          onChange={(event) => {
            const raw = event.target.value;
            const auditoriaBool = raw === 'true' ? true : raw === 'false' ? false : null;
            setValues({ ...values, auditoria: auditoriaBool });
          }}
          value={values.auditoria === true ? 'true' : values.auditoria === false ? 'false' : ''}
        />
      </Grid>
    )}
  </>
);

InformacaoBasicaForm.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  isAdmin: PropTypes.bool,
  usuarioCroquiPodeEditar: PropTypes.bool,
  podeEditarAuditoria: PropTypes.bool,
  patchNsirAuditoria: PropTypes.func,
};

InformacaoBasicaForm.defaultProps = {
  errors: null,
  isAdmin: false,
  usuarioCroquiPodeEditar: false,
  podeEditarAuditoria: false,
  patchNsirAuditoria: null,
};

export default InformacaoBasicaForm;
